/* rs-free-gift.js - the free seed packet promo (replaces the Kite app, 2026-09-29).
   Loaded by layout/theme.liquid only while Theme settings -> Cart -> Free seed promo is ticked.

   After every cart change it asks sections/rs-free-gift.liquid which packets the cart has earned
   (data-want) and which it holds (data-have), sets every packet to exactly 1 or 0 with one
   /cart/update.js call, rebuilds the drawer and cart page, and redraws each "Unlock FREE gifts" panel.
   All the rules are in snippets/rs-free-gift.liquid; this file only makes the cart match them.

   Cart changes are spotted three ways, because not all of them raise a theme event: the theme's own
   ajaxProduct:added / cart:updated events, any fetch/XHR to /cart/(add|change|update|clear), and the tab
   being shown again (a change made in another tab).

   2026-10-22 (Lauren): removing a packet is respected. A click on a gift line's remove link records the
   variant in the hidden cart attribute _rs_fg_declined before the line goes, so the sync below leaves it
   out; the panel row then offers "Add back", which takes it off the list and lets the sync re-add it.
   The attribute lives on the cart, so the choice holds across the drawer, /cart and other tabs, and a new
   cart after checkout starts clean.

   2026-10-27 (post-go-live audit CF-005): the opt-out was lost in ~1 in 5 removals. The trash click fired
   the attribute write (update.js) and let module.cart-form.js send the line removal (change.js) in the same
   tick; Shopify commits concurrent cart writes last-writer-wins, so when the removal committed second the
   attribute was gone, the panel showed a tick for a packet no longer in the cart, and the next sync put it
   back - the very "trash can looks broken" complaint the 2026-10-22 change was meant to end. Now every gift
   line's remove click is taken over here (preventDefault + stopImmediatePropagation in the capture phase,
   before the form's own listener and any app onclick): write the opt-out, THEN remove the line, THEN
   rebuild the drawer / cart page in place and redraw the panels. One path for the theme's own link and
   the EG Auto Add to Cart rewrite alike; no reload unless the cart is now empty. The local declined map is
   seeded from the panel at script start, each shopper write bumps an epoch so a sync already in flight
   cannot send a competing cart write, and a sync that finds the cart attribute missing an id the shopper
   declined in this tab writes it back.

   2026-10-27 (post-go-live audit PGL-009, John: yes): the three cart writes this file makes itself go through
   window.__rsRawFetch, the browser's fetch captured by layout/theme.liquid before content_for_header. Shopify's
   web-pixels manager wraps window.fetch and emits product_added_to_cart / product_removed_from_cart from the
   response of every wrapped /cart/update.js and /cart/change.js, so the $0 "Free Seed Variety" packet landed in
   GA4, two Google Ads conversion hits, Meta AddToCart, Klaviyo and Shopify Analytics as an add_to_cart every time
   the seed total crossed $10 (and again at every re-crossing), while the threshold drop never sent a remove.
   A write through the unwrapped fetch produces no event, now or later (measured on live, 0 of 7 pixels).
   Shopper adds are untouched: they go through the theme's form and the wrapped fetch, and still count once.
   Falls back to the wrapped fetch (today's behaviour) if the capture is ever missing. */
(function () {
  if (window.__rsFreeGift) return;
  window.__rsFreeGift = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var nativeFetch = window.fetch.bind(window);
  /* PGL-009 2026-10-27: the pre-pixel fetch for this file's OWN cart writes (postCart) - never for the
     pass-through wrapper below, which must keep handing shopper adds to the pixels */
  var rawFetch = (window.__rsRawFetch || window.fetch).bind(window);

  var timer = null;
  var running = false;
  var queued = false;
  /* A correction is itself a cart write, so it re-triggers a sync that should find nothing to do. The cap
     stops a loop if the cart ever refuses a change (a packet unpublished or out of stock); it resets on
     the next change the shopper makes. */
  var corrections = 0;
  var MAX_CORRECTIONS = 3;
  /* variant id -> true for every packet the customer took out; mirrors _rs_fg_declined, but is updated at
     the click, before the attribute write lands, so a sync in between cannot put the packet back */
  var declined = {};
  var knownGifts = [];
  /* variant id -> true while an "Add back" write is in flight: a sync reading a stale cart must not merge
     the id back into the local map and undo the restore (CF-005, 2026-10-27) */
  var restoring = {};
  /* bumped on every write the shopper triggers (remove / Add back). sync() notes the epoch when it starts
     and sends no cart write of its own if it moved meanwhile - the write would race the shopper's, and
     Shopify keeps whichever commits last (CF-005, 2026-10-27). */
  var epoch = 0;

  function parseIds(s) {
    return String(s || '').split(',').filter(Boolean);
  }
  function parseHave(s) {
    var have = {};
    parseIds(s).forEach(function (pair) {
      var p = pair.split(':');
      have[p[0]] = (have[p[0]] || 0) + (parseInt(p[1], 10) || 0);
    });
    return have;
  }

  function declinedAttr() {
    var ids = Object.keys(declined);
    return ids.length ? ',' + ids.join(',') + ',' : '';
  }
  function writeDeclined() {
    return postCart('cart/update.js', { attributes: { _rs_fg_declined: declinedAttr() } }).catch(function () {});
  }

  function giftIds() {
    if (knownGifts.length) return knownGifts;
    var panel = document.querySelector('[data-rs-fg]');
    return panel ? parseIds(panel.dataset.gifts) : [];
  }

  /* CF-005 2026-10-27: start from what the cart already holds, so a click before the first sync completes
     writes the merged list rather than only the packet just removed (no extra request on the click path) */
  (function seedDeclined() {
    var panel = document.querySelector('[data-rs-fg]');
    if (panel) parseIds(panel.dataset.declined).forEach(function (id) { declined[id] = true; });
  })();

  function postCart(path, body) {
    /* PGL-009: update.js (packet add/remove + attribute) and change.js (trashed packet) bypass the pixels */
    return rawFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* After a write the shopper made: rebuild the drawer + /cart line items in place (module.cart-form.js
     listens for cart:build), let the badge re-read the count, then sync to redraw the panels. The same
     sequence sync() uses after its own corrections. An empty cart on /cart reloads instead: the page's
     "Your cart is currently empty" state exists only in a server render. */
  function afterShopperWrite(cart) {
    if (cart && cart.item_count === 0 && document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('rs:cart-reconcile'));
    schedule(true);
  }

  function fetchState() {
    return nativeFetch(root + '?sections=rs-free-gift', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var wrap = document.createElement('div');
        wrap.innerHTML = json['rs-free-gift'] || '';
        return wrap.querySelector('[data-rs-fg]');
      });
  }

  function render(fresh) {
    /* rareseeds 2026-10-21 (PLA-041): the cart page's mystery-seed note (section.main-cart.liquid) is
       outside everything module.cart-form.js re-renders, so it kept its page-load state after a quantity
       change. data-seed-total is the qualifying spend in cents; the note carries its own threshold. */
    var seedTotal = parseInt(fresh.dataset.seedTotal, 10);
    if (!isNaN(seedTotal)) {
      document.querySelectorAll('[data-rs-mystery-note]').forEach(function (note) {
        note.hidden = seedTotal < (parseInt(note.getAttribute('data-rs-mystery-note'), 10) || 0);
      });
    }
    var box = fresh.querySelector('.rs-fg__box');
    if (!box) return;
    document.querySelectorAll('[data-rs-fg]').forEach(function (panel) {
      var bar = panel.querySelector('[data-rs-fg-toggle]');
      var open = bar && bar.getAttribute('aria-expanded') === 'true';
      var id = bar ? bar.getAttribute('aria-controls') : 'RsFreeGift-' + panel.dataset.context;
      panel.querySelector('.rs-fg__box').innerHTML = box.innerHTML;
      ['gifts', 'want', 'have', 'declined'].forEach(function (k) { panel.dataset[k] = fresh.dataset[k]; });
      var newBar = panel.querySelector('[data-rs-fg-toggle]');
      var list = panel.querySelector('.rs-fg__list');
      newBar.setAttribute('aria-controls', id);
      list.id = id;
      newBar.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
    });
  }

  function sync() {
    if (running) { queued = true; return; }
    running = true;
    var startEpoch = epoch;
    fetchState()
      .then(function (fresh) {
        if (!fresh) return;
        var want = parseIds(fresh.dataset.want);
        var have = parseHave(fresh.dataset.have);
        var onCart = parseIds(fresh.dataset.declined);
        onCart.forEach(function (id) { if (!restoring[id]) declined[id] = true; });
        knownGifts = parseIds(fresh.dataset.gifts);
        var updates = {};
        var changed = false;
        /* CF-005 2026-10-27: an id this tab declined that the cart attribute lacks (a write lost to a
           concurrent one, or a click that landed before the attribute did) is written back with the same
           update.js call, so the packet cannot come back on the next sync or page load */
        var heal = Object.keys(declined).some(function (id) { return onCart.indexOf(id) < 0; });
        parseIds(fresh.dataset.gifts).forEach(function (id) {
          var target = want.indexOf(id) >= 0 && !declined[id] ? 1 : 0;
          if ((have[id] || 0) !== target) { updates[id] = target; changed = true; }
        });
        if (!changed && !heal) { corrections = 0; render(fresh); return; }
        if (corrections >= MAX_CORRECTIONS) { render(fresh); return; }
        /* the shopper wrote meanwhile; that path rebuilds and schedules its own sync */
        if (epoch !== startEpoch) { queued = true; return; }
        corrections++;
        var body = { updates: updates };
        if (heal) body.attributes = { _rs_fg_declined: declinedAttr() };
        return postCart('cart/update.js', body)
          .then(function (r) { return r.json().catch(function () { return null; }); })
          .then(function (cart) {
          /* section.main-cart.liquid renders "Your cart is currently empty" only on the server (the whole
             form is gated on cart.item_count > 0), so taking the last line out over AJAX leaves an empty
             table, a $0.00 Summary and a live Proceed to Checkout behind - the trap module.cart-form.js
             onRemoveClick reloads out of. Do the same; the reloaded page has no form to rebuild and nothing
             left to correct, so it cannot loop. */
          if (cart && cart.item_count === 0 && document.body.classList.contains('template-cart')) {
            window.location.reload();
            return;
          }
          /* rebuild the drawer + /cart line items (module.cart-form.js), let the badge re-read the count,
             then run again to redraw the panels from the corrected cart */
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('rs:cart-reconcile'));
          queued = true;
        });
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (queued) { queued = false; schedule(); }
      });
  }

  function schedule(fromShopper) {
    if (fromShopper) corrections = 0;
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }
  function onShopperChange() { schedule(true); }

  ['ajaxProduct:added', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, onShopperChange);
  });

  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var u = String((input && input.url) || input);
      if (CART_WRITE.test(u)) p.then(onShopperChange, function () {});
    } catch (e) {}
    return p;
  };
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (url && CART_WRITE.test(String(url))) this.addEventListener('loadend', onShopperChange);
    } catch (e) {}
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(true); });
  window.addEventListener('pageshow', function () { schedule(true); });

  /* Capture phase on document: runs before module.cart-form.js's form listener and before any inline app
     onclick, so stopImmediatePropagation leaves this the only handler for a gift line's remove click.
     Line keys are "<variant id>:<hash>". The key comes from the line row's data-key (snippets/cart.line-item.liquid)
     when there is one - on /cart the EG Auto Add to Cart app rewrites every remove link to
     href="javascript:void(0)" with aca-line / aca-quantity and an onclick of its own, so the href carries no
     key there - and otherwise from the link's own /cart/change?id=...&quantity=0 href.
     CF-005 2026-10-27: both kinds of link now take the same sequenced path - write the opt-out, then remove
     the line, then rebuild in place - instead of only the app's (the theme's own link used to fire the
     attribute write and let the form send the removal at the same time, which lost the opt-out ~1 in 5).
     Other lines stay the form's / the app's. */
  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    var remove, row, key = '', variant = '';
    try {
      remove = evt.target.closest('.cart__item-remove a, a[href*="/cart/change"]');
      if (!remove) return;
      row = remove.closest('[data-key]');
      key = row ? String(row.getAttribute('data-key') || '') : '';
      if (!key) {
        var params = new URL(remove.href, window.location.origin).searchParams;
        if (params.get('quantity') !== '0') return;
        key = String(params.get('id') || '');
      }
      variant = key.split(':')[0];
    } catch (e) { return; }
    if (!key || !variant || giftIds().indexOf(variant) < 0) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (row) {
      if (row.classList.contains('is-loading')) return; /* double click: the first one is in flight */
      row.classList.add('is-loading');
    }
    declined[variant] = true;
    epoch++;
    writeDeclined()
      .then(function () { return postCart('cart/change.js', { id: key, quantity: 0 }); })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .catch(function () { return null; })
      .then(function (cart) {
        if (row) row.classList.remove('is-loading');
        afterShopperWrite(cart);
      });
  }, true);

  document.addEventListener('click', function (evt) {
    var restore = evt.target.closest && evt.target.closest('[data-rs-fg-restore]');
    if (restore) {
      var id = restore.getAttribute('data-rs-fg-restore');
      restore.disabled = true;
      delete declined[id];
      restoring[id] = true;
      epoch++;
      writeDeclined().then(function () { delete restoring[id]; schedule(true); });
      return;
    }
    var bar = evt.target.closest && evt.target.closest('[data-rs-fg-toggle]');
    if (!bar) return;
    var open = bar.getAttribute('aria-expanded') !== 'true';
    bar.setAttribute('aria-expanded', open ? 'true' : 'false');
    var list = document.getElementById(bar.getAttribute('aria-controls'));
    if (list) list.hidden = !open;
  });
})();
